const ReportsModule = () => import('@pages/generalReports/ReportsModule.vue')
const PqrsReportsPage = () => import('@pages/generalReports/pqrs/PqrsReportsPage.vue')
const AccessControlReportsPage = () => import('@pages/generalReports/accessControl/AccessControlReportsPage.vue')
const MailboxReportsPage = () => import('@pages/generalReports/mailbox/MailboxReportsPage.vue')
const FaultReportsPage = () => import('@pages/generalReports/faults/FaultReportsPage.vue')
const ManagementReportPage = () => import('@pages/generalReports/management/Index.vue')
const SupportReportPage = () => import('@pages/generalReports/support/Index.vue')
const MessagesReportPage = () => import('@pages/generalReports/messaging/Index.vue')
const MarketplaceReportPage = () => import('@pages/generalReports/marketplace/Index.vue')
const WhatsappMessagesReportPage = () => import('@pages/generalReports/whatsappMessages/Index.vue')
export default {
    path: 'general-reports',
    component: ReportsModule,
    children: [
        {
            path: 'pqrs-reports',
            component: PqrsReportsPage,
            name: 'pqrsReports',
        },
        {
            path: 'accessControl-reports',
            component: AccessControlReportsPage,
            name: 'accessControlReports',
        },

        {
            path: 'mailbox-reports',
            component: MailboxReportsPage,
            name: 'mailboxReports',
        },

        {
            path: 'fault-reports',
            component: FaultReportsPage,
            name: 'faultReports',
        },
        {
            path: 'management-report',
            component: ManagementReportPage,
            name: 'managementReport',
        },
        {
            path: 'support',
            component: SupportReportPage,
            name: 'supportReport',
        },
        {
            path: 'messages',
            component: MessagesReportPage,
            name: 'adminMessagesdIndicators',
        },
        {
            path: 'marketplace',
            component: MarketplaceReportPage,
            name: 'marketplaceReport',
        },
        {
            path: 'whatsapp-messages',
            component: WhatsappMessagesReportPage,
            name: 'whatsappMessagesReport',
        },
    ],
}
